var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 88,
    viewBox: "0 0 96 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9874 2.30282C51.5822 1.60241 51.0005 1.02102 50.3006 0.616871C49.6007 0.212723 48.8072 0 47.9996 0C47.1919 0 46.3984 0.212723 45.6985 0.616871C44.9986 1.02102 44.4169 1.60241 44.0117 2.30282L31.4994 23.9247C31.066 24.6725 30.4707 25.3132 29.7573 25.7996C29.044 26.286 28.2308 26.6056 27.3778 26.7349L3.92539 30.2846C-0.0117763 30.8855 -1.39486 35.868 1.67558 38.4194L19.1439 52.9233C20.7575 54.2683 21.5182 56.3898 21.1263 58.4559L16.5575 82.5135C16.3953 83.3679 16.4768 84.2509 16.7927 85.0609C17.1086 85.871 17.646 86.5752 18.3433 87.0928C19.0405 87.6103 19.8693 87.9201 20.7343 87.9865C21.5993 88.0529 22.4654 87.8733 23.2332 87.4683L45.3164 75.8116C46.1438 75.3752 47.0646 75.1471 47.9996 75.1471C48.9345 75.1471 49.8553 75.3752 50.6827 75.8116L72.7659 87.4683C73.5337 87.8733 74.3998 88.0529 75.2648 87.9865C76.1298 87.9201 76.9586 87.6103 77.6558 87.0928C78.3531 86.5752 78.8906 85.871 79.2065 85.0609C79.5223 84.2509 79.6038 83.3679 79.4416 82.5135L74.8728 58.4559C74.6792 57.4402 74.761 56.3911 75.1097 55.4179C75.4584 54.4447 76.0612 53.5832 76.8552 52.9233L94.3281 38.4147C97.394 35.8726 96.0109 30.8808 92.0691 30.2846L68.6259 26.7349C67.7721 26.6063 66.958 26.287 66.2438 25.8005C65.5296 25.3141 64.9336 24.6731 64.4997 23.9247L51.9874 2.30282Z",
    fill: "url(#paint0_linear_1_137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_137",
    x1: -22.7097,
    y1: 88,
    x2: 211.871,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ab06b3834ded0ff7623012146fa56d1d.svg";
export { ForwardRef as ReactComponent };